import * as errMessages from '../constants/ErrorMessages'
import { WarningAddressType } from '../constants/ComponentTypes'

export const isLength = (str, min, max) => {
  const surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  const len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
};

export const isEmpty = (str) => {
  return !str || str.length === 0;
};

export const isEmail = (str) => {
  const pattern = /\S+@\S+\.\S+/;
  return pattern.test(str);
};

export const isUrl = (str) => {
  const pattern = /^(https?|ftp)(:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+)/g;
  return pattern.test(str);
};

export const isNumeric = (str) => {
  const pattern = /^[0-9]+$/;
  return pattern.test(str);
};

export const isNumericWithHyphen = (str) => {
  const pattern = /^[0-9]([0-9]*(-)*)*[0-9]$/;
  return pattern.test(str);
};

/**
 * 電話番号が有効かどうか
 *
 * @param {string} str - 対象の文字列
 * @returns {boolean} 電話番号が有効な場合は true、無効な場合は false を返します。
 */
export const isTel = (str) => {
  const pattern_no_hyphen = /^0\d{9,10}$/;
  const pattern_with_Hyphen = /^0\d{1,3}-\d{2,4}-\d{3,4}$/;

  return pattern_no_hyphen.test(str) || pattern_with_Hyphen.test(str);
};

export const isPostcode = (str) => {
  const pattern_no_hyphen = /^[0-9]{7}$/;
  const pattern_with_Hyphen = /^[0-9]{3}(-)[0-9]{4}$/;

  return pattern_no_hyphen.test(str) || pattern_with_Hyphen.test(str);
};

export const isHoujinNumber = (str) => {
  const pattern = /^[0-9]{13}$/;
  return pattern.test(str);
}

export const isValidPassword = (str) => {
  const passwordLength = 8;
  return isLength(str, passwordLength);
}

export const isValidOldPassword = (str) => {
  const passwordLength = 6;
  return isLength(str, passwordLength);
}

export const isValidPasswordFormat = (str) => {
  const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?!.*[^a-zA-Z\d!@#$%^&*()_+-=[]{};:?,.).+$/;
  return pattern.test(str);
}

export const iskana = (str) => {
  /* eslint-disable no-irregular-whitespace */
  const pattern = /^[ァ-ヶー　]*$/;
  return pattern.test(str);
}

export const isValidAddress = (str) => {
  //都道府県のバリデーション
  const address_pattern = /[\u90FD\u9053\u5E9C\u770C]/;
  return address_pattern.test(str);
}

export const numHyphen = (str) => {
  const fullWidthAlphanumericCharacterCodeNumber = 65248;
  return str.replace(/[０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - fullWidthAlphanumericCharacterCodeNumber);
  }).replace(/[-－]/g, '').replace(/〒/g, '');
};

export const stripNewline = (str) => {
  if (str !== null && str !== undefined) {
    return str.toString().replace(/\s/gm, " ");
  } else {
    return str;
  }
};

export const replaceHyphen = (addressItem) => {
  let item = { ...addressItem };

  for (let p in addressItem) {
    if (p !== 'tags') {
      item[p] = toHalfWidthHyphen(addressItem[p]);
    } else {
      item[p] = addressItem[p].map(tag => toHalfWidthHyphen(tag));
    }
  }

  return item;
}

export const toHalfWidthHyphen = (str) => {
  return str.toString().replace(/[\uff0d\u30fc\uff70\u2013\u2796]/g, '-').replace(/[‐－―ー]/g, '-');
};

export const removalBlank = (str) => {
  /* eslint-disable no-irregular-whitespace */
  return str.replace(/[\s　]+/g, '');
};

export const zenHan = (str) => {
  // 参考: ハイフンに似てる文字の文字コード https://qiita.com/ryounagaoka/items/4cf5191d1a2763667add
  const fullWidthAlphanumericCharacterCodeNumber = 65248;

  return str.replace(/[\u30FC\u2010\u2011\u2013\u2014\u2015\u2212\uff70]/g, '-').replace(/[Ａ-Ｚａ-ｚ０-９！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - fullWidthAlphanumericCharacterCodeNumber);
  });
};

export const containsSymbol = (str) => {
  //都道府県のバリデーション
  const address_pattern = /^[^<>()（）?\ufffd]*([(（](株|有)[）)])?[^<>()（）?\ufffd]*$/u;
  return !address_pattern.test(str.toString());
}

export const validateAddressItem = (item) => {
  var error = {};
  for (var property in item) {
    var err = validateProperty(item[property], item, property);
    for (var p in err) error[p] = err[p];
  }

  return error;
};

/**
 * 自社リストの登録バリデーション
 * validateAddressItemとほぼ同じだが、validateAddressItemは使用箇所が多いので、自社リストアドレス登録ではこちらを利用する
 *
 * @param {Object} item - バリデーション対象
 * @param {boolean} isFollowCallAddress - フォローコールアドレスかどうかのフラグ
 * @returns {Object} - バリデーションエラー情報を含むオブジェクト
 */
export const validateHouseAddressItem = (item, isFollowCallAddress) => {
  // フォローコールアドレスかレター送付アドレスかによって利用するバリデーションを指定
  const validateAddressProperty = isFollowCallAddress ? validateFollowCallAddressProperty : validateHouseAddressProperty;
  var error = {};

  for (const property in item) {
    const err = validateAddressProperty(item[property], item, property);
    Object.assign(error, err);
  }

  return error;
};

export const validateAddressExcelItem = (item) => {
  for (var property in item) {
    if (property === "honorific" || property === "post_code") {
      if (isEmpty(item[property])) { //empty check
        return false;
      }
    } else if (property === "name" || property === "company") {
      if (property === "name") {
        if (item.hasOwnProperty("company") && isEmpty(item['company'])) {
          return false;
        }
      } else {
        if (item.hasOwnProperty("name") && isEmpty(item['name'])) {
          return false;
        }
      }
    }
  }

  return true;
};

/**
 * フォローコールアドレスのExcelファイルから登録するバリデーション
 *
 * @param {object} item - バリデーション対象
 * @returns {boolean}
 */
export const validateFollowCallAddressExcelItem = (item) => {
  for (var property in item) {
    if (property === "name" || property === "company" || property === "tel") {
      if (isEmpty(item[property])) { //empty check
        return false;
      }
    }
  }

  return true;
};

export const validateWarningAddressItem = (item) => {
  var warning = {};
  if (item.type === WarningAddressType.CONTAINS_SYMBOL.value) {
    for (var property in item) {
      if (item && item[property] && containsSymbol(item[property])) {
        warning[property] = errMessages.ERR_CONTAINS_SYMBOL;
      }
    }
  } else if (item.type === WarningAddressType.INVALID_ADDRESS_REPEATING_PATTERNS.value) {
    warning['address'] = WarningAddressType.INVALID_ADDRESS_REPEATING_PATTERNS.text;
  } else if (item.type === WarningAddressType.INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA.value) {
    warning['address'] = WarningAddressType.INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA.text;
    warning['post_code'] = WarningAddressType.INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA.text;
  } else if (item.type === WarningAddressType.ADDRESS_LENGTH.value) {
    warning['address'] = WarningAddressType.ADDRESS_LENGTH.value.text;
  } else if (item.type === WarningAddressType.INVALID_POSTCODE.value) {
    warning['post_code'] = WarningAddressType.INVALID_POSTCODE.text;
  }

  return warning;
};

// validatePropertyとほぼ同じだが、validatePropertyは使用箇所が多いので、自社リストアドレス登録ではこちらを利用する
export const validateHouseAddressProperty = (value, curValues, property) => {
  var error = {};

  if (property === "postcode" || property === "post_code") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    } else if (!isPostcode(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "company" || property === "company_name") {
    if (isEmpty(value)) {
      if ((curValues.hasOwnProperty("company_name") && isEmpty(curValues['company_name'])) ||
        (curValues.hasOwnProperty("company") && isEmpty(curValues['company']))) {
        error[property] = errMessages.ERR_EMPTY; //empty check
      }
    }
  } else if (property === "name") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === "honorific" || property === "suffix") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === "address") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    } else if (!isValidAddress(value)) {
      error[property] = errMessages.ERR_ADDRESS;
    }
  } else if (property === "tel") {
    if (!isEmpty(value) && !isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "fax") {
    if (!isEmpty(value) && !isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "email") {
    if (!isEmpty(value) && !isEmail(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === 'country') {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === 'newPassword') {
    if (!isEmpty(value) && !isValidPassword(value)) {
      error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT;
    } else if (!isValidPasswordFormat(value)) {
      error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT_INVALID;
    }
  } else if (property === 'oldPassword') {
    if (!isEmpty(value) && !isValidOldPassword(value)) {
      error[property] = errMessages.ERR_BAD_OLD_PASSWORD_FORMAT;
    }
  }

  return error;
};

/**
 * フォローコールアドレス登録のバリデーション
 *
 * @param {string} value - バリデーション対象の値
 * @param {Object} curValues - 現在の値を含むオブジェクト
 * @param {string} property - バリデーションするプロパティ名
 * @returns {Object} - バリデーションエラーがある場合はエラーオブジェクト、ない場合は空のオブジェクト
 */
export const validateFollowCallAddressProperty = (value, curValues, property) => {
  var error = {};

  if (property === "postcode" || property === "post_code") {
    if (!isEmpty(value) && !isPostcode(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "company" || property === "company_name") {
    if (isEmpty(value)) {
      if ((curValues.hasOwnProperty("company_name") && isEmpty(curValues['company_name'])) ||
        (curValues.hasOwnProperty("company") && isEmpty(curValues['company']))) {
        error[property] = errMessages.ERR_EMPTY; //empty check
      }
    }
  } else if (property === "name") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === "address") {
    if (!isEmpty(value) && !isValidAddress(value)) {
      error[property] = errMessages.ERR_ADDRESS;
    }
  } else if (property === "tel") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    } else if (!isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "fax") {
    if (!isEmpty(value) && !isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "email") {
    if (!isEmpty(value) && !isEmail(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === 'country') {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  }

  return error;
};

export const validateProperty = (value, curValues, property) => {
  var error = {};

  if (property === "postcode" || property === "post_code") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    } else if (!isPostcode(value)) { //formate check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "company" || property === "name" || property === "company_name") {
    if (isEmpty(value)) {
      if (property === "name") {
        if ((curValues.hasOwnProperty("company_name") && isEmpty(curValues['company_name'])) ||
          (curValues.hasOwnProperty("company") && isEmpty(curValues['company']))) {
          error[property] = errMessages.ERR_EMPTY;
        }
      } else {
        if (curValues.hasOwnProperty("name") && isEmpty(curValues['name'])) {
          error[property] = errMessages.ERR_EMPTY;
        }
      }
    }
  } else if (property === "honorific" || property === "suffix") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === "address") {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    } else if (!isValidAddress(value)) {
      error[property] = errMessages.ERR_ADDRESS;
    }
  } else if (property === "tel") {
    if (!isEmpty(value) && !isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "fax") {
    if (!isEmpty(value) && !isTel(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === "email") {
    if (!isEmpty(value) && !isEmail(value)) { //format check
      error[property] = errMessages.ERR_BAD_FORMAT;
    }
  } else if (property === 'country') {
    if (isEmpty(value)) { //empty check
      error[property] = errMessages.ERR_EMPTY;
    }
  } else if (property === 'newPassword') {
    if (!isEmpty(value) && !isValidPassword(value)) {
      error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT;
    } else if (!isValidPasswordFormat(value)) {
      error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT_INVALID;
    }
  } else if (property === 'oldPassword') {
    if (!isEmpty(value) && !isValidOldPassword(value)) {
      error[property] = errMessages.ERR_BAD_OLD_PASSWORD_FORMAT;
    }
  }

  return error;
};

export const validateCheckout = (checkoutInfo) => {
  var error = {};
  for (let p in checkoutInfo) {
    let value = checkoutInfo[p];
    if (p === 'cardNumber') {
      const cardMinLength = 13;
      const cardMaxLength = 19;
      if (isEmpty(value)) error[p] = errMessages.ERR_EMPTY;
      else if (!isLength(value, cardMinLength, cardMaxLength)) error[p] = errMessages.ERR_BAD_FORMAT;
    } else if (p === 'month' || p === 'year') {
      if (value === 0) error[p] = errMessages.ERR_EMPTY_SELECTION;
    } else if (p === 'cvc') {
      const cvcMinLength = 3;
      const cvcMaxLength = 4;
      if (isEmpty(value)) error[p] = errMessages.ERR_EMPTY;
      else if (!isLength(value, cvcMinLength, cvcMaxLength)) error[p] = errMessages.ERR_BAD_FORMAT;
    }
  }

  return error;
}

export const validateSignup = (signupInfo) => {
  var error = {};
  for (let property in signupInfo) {
    let value = signupInfo[property];
    if (isEmpty(value)) error[property] = errMessages.ERR_EMPTY;

    if (property === "email") {
      if (!isEmpty(value) && !isEmail(value)) {
        error[property] = errMessages.ERR_BAD_FORMAT;
      }
    } else if (property === 'password') {
      if (!isEmpty(value) && !isValidPassword(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT;
      } else if (!isValidPasswordFormat(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT_INVALID;
      }
    }
  }
  return error;
}

export const validateSignin = (loginInfo) => {
  var error = {};
  for (let property in loginInfo) {
    let value = loginInfo[property];
    //ログインは空チェックだけ
    if (isEmpty(value)) error[property] = errMessages.ERR_EMPTY;
  }
  return error;
}

export const validateResetPassword = (info, isChildEdit = false) => {
  var error = {};
  for (let property in info) {
    let value = info[property];
    //ログインは空チェックだけ
    if (isEmpty(value)) error[property] = errMessages.ERR_EMPTY;
    if (property === "email") {
      if (!isEmpty(value) && !isEmail(value)) {
        error[property] = errMessages.ERR_BAD_FORMAT;
      }
    } else if (property === 'password') {
      if (!isEmpty(value) && !isValidPassword(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT;
      } else if (!isValidPasswordFormat(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT_INVALID;
      } else if (isChildEdit === false && !isEmpty(value) && info['password_old'] === value) { // 親アカウントから子アカウントの操作でPWを変更する場合は、元のPWの入力はないのでエラーとしない
        error[property] = errMessages.ERR_BAD_PASSWORD_USE_NEW_PW;
      }
    } else if (property === 'confirm_password') {
      if (!isEmpty(value) && value !== info.password) {
        error[property] = errMessages.ERR_PASSWORD_NOT_MATCHED;
      }
    }
  }
  return error;
}

export const validateChildAccount = (info) => {
  var error = {};
  for (let property in info) {
    let value = info[property];
    if (isEmpty(value)) error[property] = errMessages.ERR_EMPTY;

    if (property === "kana") {
      if (!isEmpty(value) && !iskana(value)) {
        error[property] = errMessages.ERR_BAD_KANA_FORMAT;
      }
    } else if (property === "email") {
      if (!isEmpty(value) && !isEmail(value)) {
        error[property] = errMessages.ERR_BAD_FORMAT;
      }
    } else if (property === 'password') {
      if (!isEmpty(value) && !isValidPassword(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT;
      } else if (!isValidPasswordFormat(value)) {
        error[property] = errMessages.ERR_BAD_PASSWORD_FORMAT_INVALID;
      }
    } else if (property === 'confirm_password') {
      if (!isEmpty(value) && value !== info.password) {
        error[property] = errMessages.ERR_PASSWORD_NOT_MATCHED;
      }
    }
  }
  return error;
}

export const validateNgItem = (info) => {
  var error = {};
  for (let property in info) {
    let value = info[property];

    if (property === "corporate_number") {
      if (isEmpty(value)) {
        error[property] = errMessages.ERR_EMPTY;
      } else if (!isHoujinNumber(value)) {
        error[property] = errMessages.ERR_BAD_HOUJIN_NUMBER_FORMAT;
      }
    }
  }

  return error;
}

export const validateNgExcel = (data) => {
  let valid = false;

  const hasNoDataMaxLength = 2;

  if (data.length > hasNoDataMaxLength) {
    if (data[0]["rowIndex"].indexOf("送付NGリストテンプレート") !== -1 &&
      data[1]["rowIndex"] === "番号" &&
      data[1]["corporate_number"].indexOf("法人番号") !== -1 &&
      data[1]["name"].indexOf("氏名") !== -1) {
      valid = true;
    }
  }

  return valid;
}

/**
 * Excelデータが有効なフォーマットかどうか
 *
 * @param {Array} data - Excelデータの配列
 * @param {boolean} isFollowCallAddress - フォローコールアドレスの場合はtrue、それ以外の場合はfalse
 * @returns {boolean} - データが有効なフォーマットの場合はtrue、それ以外の場合はfalse
 */
export const validateAddressExcel = (data, isFollowCallAddress) => {
  let valid = false;

  const hasNoDataMaxLength = 2;

  if (data.length > hasNoDataMaxLength) {
    if (isFollowCallAddress) {
      if (data[0]["rowIndex"].indexOf("フォローコールリストテンプレート") !== -1 &&
        data[1]["company"].indexOf("組織名") !== -1 &&
        data[1]["name"].indexOf("名前") !== -1 &&
        data[1]["tel"].indexOf("電話番号") !== -1) {
        valid = true;
      }
    } else {
      if (data[0]["rowIndex"].indexOf("宛先リストテンプレート") !== -1 &&
        data[1]["post_code"].indexOf("郵便番号") !== -1 &&
        data[1]["honorific"].indexOf("敬称") !== -1 &&
        data[1]["address"].indexOf("住所") !== -1 &&
        data[1]["name"].indexOf("名前") !== -1) {
        valid = true;
      }
    }
  }

  return valid;
}

export const validateSender = (item) => {
  let error = {}
  for (var property in item) {
    switch (property) {
      case 'post_code':
        if (!isEmpty(item[property]) && !isPostcode(item[property])) {
          error[property] = errMessages.ERR_BAD_FORMAT;
        }
        break;
      case 'name':
        if (isEmpty(item[property])) {
          error[property] = errMessages.ERR_EMPTY;
        }
        break;
      case 'address':
        if (!isEmpty(item[property]) && !isValidAddress(item[property])) {
          error[property] = errMessages.ERR_ADDRESS;
        }
        break;
      default:
        break;
    }
  }

  return error;
}

export const validateAddressSendLetter = (item) => {
  var error = {};
  for (var property in item) {
    if (property === 'honorific') {
      continue;
    }
    var err = validateProperty(item[property], item, property);
    for (var p in err) error[p] = err[p];
  }

  return error;
};

export const validateUserMail = (item) => {
  let error = {}
  for (var property in item) {
    switch (property) {
      case 'name':
        if (isEmpty(item[property])) {
          error[property] = errMessages.ERR_EMPTY;
        }
        break;
      case 'email':
        if (isEmpty(item[property])) {
          error[property] = errMessages.ERR_EMPTY;
        } else if (!isEmail(item[property])) { //format check
          error[property] = errMessages.ERR_BAD_FORMAT;
        }
        break;
      default:
        break;
    }
  }

  return error;
}

/**
 * アンケートデータのバリデーション
 *
 * @param {Object} questionnaire - バリデーション対象のアンケートデータ
 * @returns {Object} - バリデーションエラーがある場合はエラーオブジェクト、ない場合は空のオブジェクト
 */
export const validateQuestionnaire = (questionnaire) => {
  var error = {};

  // アンケートデータをセクションごとに検証
  for (let section in questionnaire) {
    error[section] = {};
    let sectionData = questionnaire[section];
    for (let property in sectionData) {
      switch (property) {
        // 空かどうかを検証
        case 'name':
          if (isEmpty(sectionData[property])) {
            error[section][property] = errMessages.ERR_EMPTY;
          }
          break;
        // メールアドレスが空か、正しい形式かどうかを検証
        case 'email':
          if (isEmpty(sectionData[property])) {
            error[section][property] = errMessages.ERR_EMPTY;
          } else if (!isEmail(sectionData[property])) {
            error[section][property] = errMessages.ERR_BAD_FORMAT;
          }
          break;
        // 選択が空かどうかを検証
        case 'good':
        case 'improving':
        case 'target_select':
        case 'target_interest_level':
        case 'improving_quality':
          if (isEmpty(sectionData[property])) {
            error[section][property] = errMessages.ERR_EMPTY_SELECTION;
          }
          break;
        default:
          break;
      }
    }
  }

  return error;
}


// WEBPACK FOOTER //
// ./src/utils/validator.js